import { ArrowUpRight } from "lucide-react";
import { ENGAGEMENTS, IMG } from "./data";
import { Eyebrow, MaskLines, Reveal } from "./motion";
import { scrollToId } from "@/lib/scroll";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4"];

const Card = ({ e, i }) => (
  <Reveal delay={(i % 3) * 0.08} className={`${SPANS[i]} md:col-span-1`}>
    <article data-testid={`enterprise-card-${e.id}`} className="group relative h-full min-h-[260px] overflow-hidden border border-white/10 bg-[#0B0F17] p-7 sm:p-9 flex flex-col justify-between transition-colors duration-500 hover:border-cyan-300/40">
      {i === 0 && (
        <>
          <img src={IMG.cables} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 transition-[transform,opacity] duration-[1.4s] group-hover:scale-105 group-hover:opacity-45" />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#0B0F17] via-[#0B0F17]/80 to-transparent" />
        </>
      )}
      <div className="absolute -right-24 -top-24 h-48 w-48 rounded-full bg-cyan-400/0 blur-3xl transition-colors duration-700 group-hover:bg-cyan-400/20" />
      <div className="relative flex items-center justify-between">
        <span className="font-mono text-[11px] tracking-[0.2em] text-cyan-300">{e.k}</span>
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{e.vendors}</span>
      </div>
      <div className="relative mt-12">
        <h3 className={`font-display font-semibold tracking-tight ${i === 0 ? "text-3xl sm:text-4xl max-w-md" : "text-2xl"}`}>{e.title}</h3>
        <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed max-w-md">{e.body}</p>
      </div>
    </article>
  </Reveal>
);

export const Enterprise = () => (
  <section id="enterprise" className="relative py-24 md:py-36" data-testid="enterprise-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 mb-14 md:mb-20 items-end">
        <div className="lg:col-span-8">
          <Eyebrow>Enterprise consultancy</Eyebrow>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1]">
            <MaskLines lines={["Cisco, Palo Alto,", <>Fortinet <span className="font-serif-i font-normal text-cyan-300">&amp;</span> Azure.</>]} />
          </h2>
        </div>
        <Reveal className="lg:col-span-4">
          <p className="text-slate-400 leading-relaxed">For larger estates: audits, SD-WAN migrations, firewall architecture and hybrid cloud — working alongside your in-house team.</p>
          <button onClick={() => scrollToId("contact")} data-testid="enterprise-cta" className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-cyan-300 hover:text-white transition-colors">
            Discuss an engagement <ArrowUpRight size={14} />
          </button>
        </Reveal>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-4">
        {ENGAGEMENTS.map((e, i) => <Card key={e.id} e={e} i={i} />)}
      </div>
    </div>
  </section>
);
